import {PlayrateState} from '../../reducers/fortnite-game/playrate.reducer';

export const getPlayrateState = (state): PlayrateState => {
    return state.get('playrate').toJS();
};
